"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _text = _interopRequireDefault(require("@ux/text"));
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../../../elements/other/actions/index"));
var _configContext = require("../../../mega-marquee/config-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TooltipContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TooltipContainer",
  class: "pl-t1ljxn",
  vars: {
    "t1ljxn-2": [({
      open
    }) => open ? 1 : 0],
    "t1ljxn-3": [({
      open
    }) => open ? 'visible' : 'hidden'],
    "t1ljxn-5": [({
      open
    }) => open ? 'none' : 'initial'],
    "t1ljxn-7": [({
      position
    }) => position.top, "px"],
    "t1ljxn-8": [({
      position
    }) => position.left, "px"]
  }
});
const innerStyles = "pl-i15409sf";
const innerStylesRTL = "pl-i9slq84";
const Inner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Inner",
  class: "pl-ifuggos",
  vars: {
    "ifuggos-2": [({
      open
    }) => open ? 'translateY(0px)' : 'translateY(100vh)'],
    "ifuggos-5": [({
      open
    }) => open ? 'translate3d(0px, 0px, 0px)' : 'translate3d(0.625rem, 0px, 0px)']
  }
});
const closeButtonStyles = "pl-cpfulty";
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c1pny75x"
});
const MobileContent = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "MobileContent",
  class: "pl-m1by7va7"
});

/**
 * Tooltip Component.
 *
 * @param {Object} props React props
 * @param {String} props.tooltipText Text to display
 * @param {Object} props.image Image to display
 * @param {Array} props.ctas Buttons (Optional)
 * @param {String} props.content Content Heading for Mobile
 * @param {Boolean} props.isOpen Open state
 * @param {Function} props.setIsOpen Forwarded Function
 * @param {Object} props.position Position of the tooltip
 * @param {Object} props.tooltipRef Ref for tooltip
 * @returns {React.ReactElement} Tooltip Component
 * @public
 */

function Tooltip({
  tooltipText,
  image = {},
  ctas,
  content,
  isOpen,
  setIsOpen,
  position,
  tooltipRef
}) {
  const {
    url,
    altText,
    loading = 'eager',
    show
  } = image;
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const config = (0, _react.useContext)(_configContext.ConfigContext);
  const layout = config?.layout ?? 'default';

  // Disable Scroll When Tooltip Open
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined' && isOpen && width <= _patternLibraryUtils.size.laptop) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [isOpen, width]);
  return /*#__PURE__*/_react.default.createElement(TooltipContainer, {
    ref: tooltipRef,
    "data-cy": "tooltip-container",
    open: isOpen,
    layout: layout,
    position: position
  }, /*#__PURE__*/_react.default.createElement(Inner, {
    open: isOpen,
    className: config?.layout === 'image-right' ? innerStylesRTL : innerStyles
  }, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: setIsOpen,
    className: closeButtonStyles
  }), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: url,
    defaultAltText: altText,
    width: image?.width,
    height: image?.height,
    loading: loading,
    show: show
  }), /*#__PURE__*/_react.default.createElement(MobileContent, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 2,
    text: content
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: tooltipText
  }), ctas && /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "tooltip-cta-container",
    className: "tooltip-cta-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })))));
}
var _default = exports.default = Tooltip;
Tooltip.propTypes = {
  tooltipText: _propTypes.default.string,
  image: _propTypes.default.object,
  ctas: _propTypes.default.array,
  content: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  setIsOpen: _propTypes.default.func,
  position: _propTypes.default.object,
  tooltipRef: _propTypes.default.object
};